import extractRowFromData from './extractRowFromData'

function extractRowsFromData(data) {
  return data.rows.map((row, rowIndex) => extractRowFromData({ data, rowIndex }))
}


export default extractRowsFromData
